import { create } from 'zustand';
import API from '@/api/api';

const useSiteStore = create((set) => ({
  EstimateSites: [],

  fetchEstimateSites: async (estimate_info_id) => {
    let EstimateSitesInfo = await API.get(`/estimates/${estimate_info_id}/sites`);
    set({ EstimateSites: EstimateSitesInfo.data });
  },
}));

export default useSiteStore;
